module.exports = __webpack_public_path__ + "img/PG.bcac341b.png";